import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component';
import { takeUntil } from 'rxjs/operators';
import { CheckBrachAccessModel } from 'src/app/gnr/data-center-process/chek-branch-access.model';
import { SaleMethodBranchForm } from '../sale-method-branch-form/sale-method-branch-form';

@Component({
  selector: 'ngx-sale-method-branch-list',
  templateUrl: './sale-method-branch-list.html',
  styleUrls: ['./sale-method-branch-list.scss']
})
export class SaleMethodBranchList  extends BaseListComponent {
  IgnoreDelete: boolean = false;
  deleteMessage: string = '';
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor() {
    super()
   this.inputEditorform = SaleMethodBranchForm;
   this.FillData();
  }
  ngOnInit() {
    this.apiName= "SaleMethodBranch";
    this.label = this.translate('ClientApp.FrontOffice.SALE.SaleMethod.SaleMethodBranch');
    this.areaName = "RestaurantSale"
  }
  async FillData() {
    const currentBranch = this.accountService.authService.currentInformation();
    if (currentBranch.BranchingLightEnabled ||
      currentBranch.BranchingAdvancedEnabled ||
      currentBranch.RestaurantCallCenter) {
        if(!this.accountService.authService.currentBranch.AccessToAllBranches){
          this.isAdd = false;
          this.isDelete = false;
        }
        if(this.accountService.authService.currentBranch.AccessToAllBranches){
          this.isEdit = false;
          this.isDelete = false;
        }
       
    }
  }
}